import { useTranslation } from "react-i18next";
import {
  getClassroomManagement,
  useCreateClassroomManagement,
  useGetClassroomManagement,
} from "@packages/api/madlenAPI";
import {
  ClassroomManagementCreateRequestDtoCourseName,
  ClassroomManagementResponseDto,
} from "@packages/api/madlenAPI.schemas";
import ClassroomManagementCard from "../../../components/classroom-management/ClassroomManagementCard";
import GenericToolCreationPage from "../../../components/tool_components/GenericToolCreationPage";
import {
  ClassroomManagementCreateModal,
  CreateModalProps,
} from "@features/tools/components/create-modal/modals";

const CreateClassroomManagementView = () => {
  const { t } = useTranslation();

  const CreateModalWrapper = ({
    initialInput,
    onSubmit,
    isLoading,
    error,
  }: Partial<CreateModalProps>) => (
    <ClassroomManagementCreateModal
      title={t("classroomManagement.result.loading.title")}
      backPath="/content/classroom-management"
      loadingTitle={t("classroomManagement.result.loading.title")}
      errorTitle={t("classroomManagement.result.error.title")}
      errorDescription={t("classroomManagement.result.error.description")}
      submitButtonText={t("common.generate")}
      initialInput={initialInput!}
      onSubmit={async (input) => {
        await onSubmit!(input);
      }}
      isLoading={isLoading!}
      error={error!}
    />
  );

  const ToolCardWrapper = ({
    toolData,
    isImageLoading,
    onCreateAgain,
  }: {
    toolData: ClassroomManagementResponseDto;
    isImageLoading?: boolean;
    onCreateAgain: () => void;
  }) => (
    <ClassroomManagementCard
      tools={toolData}
      isImageLoading={isImageLoading}
      onCreateAgain={onCreateAgain}
    />
  );

  return (
    <GenericToolCreationPage
      toolType="classroom-management"
      useCreateTool={useCreateClassroomManagement}
      useGetTool={useGetClassroomManagement}
      getTool={getClassroomManagement}
      ToolCard={ToolCardWrapper}
      CreateModalWrapper={CreateModalWrapper}
      toolDataExtractor={(data: ClassroomManagementResponseDto) =>
        data?.strategies
      }
    />
  );
};

export default CreateClassroomManagementView;
